<template>
  <div class="about">
    <h1>Generate lists of hashtags</h1>

    <router-link to="/generate-hash-tag-lists">
      <button>Get started</button>
    </router-link>
  </div>
</template>
